import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const selectAppFeatureState = createFeatureSelector<State>('app');

export const selectActiveHttpRequestCount = createSelector(
   selectAppFeatureState,
   state => state.activeHttpRequestCount
);
